import { render, staticRenderFns } from "./DataSyncView.vue?vue&type=template&id=318a1184"
import script from "./DataSyncView.vue?vue&type=script&lang=js"
export * from "./DataSyncView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports